import { useCallback, useState } from 'react';

import cross from '~/assets/icons/cross.svg';
import save from '~/assets/icons/save.svg';

import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { Divider } from '~/components/ui/Divider';
import { Text } from '~/components/ui/Text';
import { TextInput } from '~/components/ui/TextInput';
import { rage, useInputAction, useObservable } from '~/rage';
import { InputAction } from '~/shared';
import { hideModal, setUnsavedChanges, useLayoutDispatch } from '../../redux';
import {
	StyledButtonsContainer,
	StyledCloseButtonContainer,
	StyledContainer,
	StyledModalBody,
	StyledModalHead,
	StyledModalHeading,
	StyledModalWrapper,
	StyledSaveInfoContainer,
} from './Modal.styled';

const Modal: React.FC = () => {
	const dispatch = useLayoutDispatch();

	const vehicleName = useObservable(rage.vehicles.getLocalVehicleName());
	const [inputName, setInputName] = useState<string>('');
	const [inputDesc, setInputDesc] = useState<string>('');
	const mode = useObservable(rage.vehicles.getLocalVehicleHandlingMode());

	const handleSave = useCallback(() => {
		if (!inputName.trim()) {
			rage.notifications.showError('Название не может быть пустым');
			return;
		}

		rage.handlingTuning
			.addPreset(inputName, inputDesc)
			.catch((err) => rage.notifications.showException(err));
		dispatch(setUnsavedChanges(false));
		dispatch(hideModal());
	}, [inputName, inputDesc]);

	useInputAction(InputAction.CommonMenuAccept, handleSave);

	useInputAction(InputAction.CommonMenuClose, () => {
		dispatch(hideModal());
	});

	return (
		<StyledModalWrapper>
			<StyledContainer>
				<StyledModalHead>
					<StyledModalHeading>
						<img src={save} />
						<Text>Сохранение настроек</Text>
					</StyledModalHeading>
					<StyledCloseButtonContainer onClick={() => dispatch(hideModal())}>
						<img width={10} height={10} src={cross} />
					</StyledCloseButtonContainer>
				</StyledModalHead>
				<Divider
					$direction={'H'}
					style={{ marginTop: 30, marginBottom: 30, opacity: 0.1 }}
				/>
				<StyledModalBody>
					<TextInput
						type={'text'}
						placeholder={'Придумайте название'}
						onChange={(e) => setInputName(e.target.value)}
						height={50}
						fontSize={16}
						padding={'0 20px'}
						active={!!inputName.trim()}
					></TextInput>
					<TextInput
						type={'text'}
						placeholder={'Доп. информация'}
						onChange={(e) => setInputDesc(e.target.value)}
						height={50}
						fontSize={16}
						padding={'0 20px'}
						active={!!inputDesc.trim()}
					></TextInput>
					<Divider
						$direction={'H'}
						style={{ marginTop: 10, marginBottom: 10, opacity: 0.1 }}
					/>
					<StyledSaveInfoContainer>
						<Text>Модель</Text>
						<Text>{vehicleName}</Text>
						<Text>Режим</Text>
						<Text style={{ textTransform: 'capitalize' }}>{mode}</Text>
					</StyledSaveInfoContainer>
				</StyledModalBody>
				<StyledButtonsContainer>
					<Button
						color={ButtonColors.Default}
						height={ButtonHeight.Height50}
						onClick={() => dispatch(hideModal())}
					>
						<Text>Отменить</Text>
					</Button>
					<Button
						color={ButtonColors.Select}
						height={ButtonHeight.Height50}
						onClick={handleSave}
					>
						<Text>Сохранить</Text>
					</Button>
				</StyledButtonsContainer>
			</StyledContainer>
		</StyledModalWrapper>
	);
};

export { Modal };
